<template>
  <transition :name="transitionType">
    <i class="bubble" :class="[{ small }, {top: arrowClass.top, bottom: arrowClass.bottom, center: arrowClass.center}, {'no-apply-center': noApplyCenterAnimate}]">
      <i v-if="arrowClass" class="arrow" :class="arrowClass"></i>
      <span class="text"><slot/></span>
    </i>
  </transition>
</template>

<script>
export default {
  name: 'UiTooltip',
  props: {
    arrowBottom: {
      type: Boolean,
      default: false
    },
    arrowLeft: {
      type: Boolean,
      default: false
    },
    arrowRight: {
      type: Boolean,
      default: false
    },
    arrowTop: {
      type: Boolean,
      default: false
    },
    arrowCenter: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    noApplyCenterAnimate: {
      type: Boolean,
      default: false
    },
    arrowLeftSide: {
      type: Boolean,
      default: false
    },
    arrowRightSide: {
      type: Boolean,
      default: false
    },
    transitionType: {
      type: String,
      default: 'slide-fade'
    },
    arrowNone: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    arrowClass () {
      if (this.arrowNone) {
        return false
      } else {
        return {
          bottom: !this.arrowTop && !this.arrowLeftSide && !this.arrowRightSide,
          left: !this.arrowRight && !this.arrowCenter,
          top: this.arrowTop,
          right: this.arrowRight,
          center: this.arrowCenter,
          leftSide: this.arrowLeftSide,
          rightSide: this.arrowRightSide
        }
      }
    }
  }
}
</script>

<style lang="scss">
.bubble {
  position: absolute;
  z-index: 5;
  border-radius: 8px;
  -webkit-box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  opacity: 1;

  &.small {
    border-radius: 6px;
  }

  .arrow {
    content: '';
    background-color: #fff;
    position: absolute;
    z-index: 2;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;

    &.top {
      -webkit-box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
      box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
      top: -4px;

      &.left {  left: 14px;  }
      &.center {  top: -8px;  left: 50%;  transform: rotate(-45deg) translateX(-50%);  }
      &.right {  right: 14px;  }
    }

    &.bottom {
      bottom: -5px;
      -webkit-box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
      box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);

      &.left {  left: 14px;  }
      &.center {  bottom: -1px; left: 50%;  transform: rotate(-45deg) translateX(-50%); }
      &.right {  right: 14px;  }
    }

    &.leftSide {
      width: 7px;
      height: 7px;
      top: 50%;
      left: -6px;
      transform: rotate(45deg) translateY(calc(-50% - 1px));
      box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
    }

    &.rightSide {
      width: 7px;
      height: 7px;
      top: 50%;
      right: 1px;
      transform: rotate(-135deg) translateY(calc(-50% + 9px));
      box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
    }
  }

  .text {
    white-space: nowrap;
    font-size: 13px;
    line-height: 1.46;
    color: #444444;
    text-align: center;
    display: inline-block;

    em {
      color: #ec0147;
    }
  }
}

// transition

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
  opacity: 1;
}
.fade-enter,
.fade-leave-to{
  opacity: 0;
}

.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter-active {
  transition: all .1s ease;
}
.bottom {
  &.slide-fade-enter, &.slide-fade-leave-to {
    opacity: 0;
  }
}
.top {
  &.slide-fade-enter, &.slide-fade-leave-to {
    opacity: 0;
  }
}

.slide-bounce-enter-active {
  animation: bounce-in .3s ease;
}
.slide-bounce-leave-active {
  animation: bounce-in .3s reverse ease;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.center {
  &.slide-bounce-enter-active {
    animation: bounce-in-center .3s ease;
  }
  &.slide-bounce-leave-active {
    animation: bounce-in-center .3s reverse ease;
  }
}
@keyframes bounce-in-center {
  0% {
    transform: translateX(-50%) scale(0);
  }
  50% {
    transform: translateX(-50%) scale(1.2);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}
</style>
